import React from "react";
import * as Mui from "@mui/material";
import { DashboardLayout } from "component/layout/dashboard";
import { ColdFusionIframe } from "component/shared/iframe/coldfusion";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";

interface Props extends PageProps, Router.RouteComponentProps {
}

class Component extends React.Component<Props> {

	public render() {
		const { user } = this.props;
		const title = "Search Neighborhoods";
		return (
			<DashboardLayout
				permitted={user && (user.permissions.listingSearch || user.permissions.listingMapSearch) && user.permissions.neighborhoods}
				title={title}
				header={
					<Mui.Typography variant="h1">
						<FeatherIcon>
							<Icons.Settings />
						</FeatherIcon>
						{title}
					</Mui.Typography>
				}
				iframe={<ColdFusionIframe url="/searchNeighborhoods.cfm" />}
			/>
		);
	}

}

export const SettingsSearchNeighborhoodsPage = Component;